import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CarouselModule} from 'ngx-owl-carousel-o';
import {BadgeModule} from 'primeng/badge';
import {SidebarModule} from "primeng/sidebar";
import {ButtonModule} from "primeng/button";
import {InputTextModule} from "primeng/inputtext";
import {TranslateModule} from "@ngx-translate/core";
import {DividerModule} from 'primeng/divider';
import {ToastModule} from 'primeng/toast';
import {InputSwitchModule} from 'primeng/inputswitch';
import {RatingModule} from 'primeng/rating';
import {ProgressBarModule} from 'primeng/progressbar';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {OverlayPanelModule} from 'primeng/overlaypanel';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {RouterModule} from "@angular/router";
import {ProductCardComponent} from "../components/product-card/product-card.component";
import {ProductSliderComponent} from "../components/product-slider/product-slider.component";
import {SectionComponent} from "../components/section/section.component";
import {CategoryCardComponent} from '../components/category-card/category-card.component';
import {PaginatorModule} from 'primeng/paginator';
import {BreadcrumbModule} from 'primeng/breadcrumb';

import {MatMenuModule} from '@angular/material/menu';
import {TieredMenuModule} from 'primeng/tieredmenu';
import {ModalModule} from 'ngx-bootstrap/modal';
import {DialogModule} from 'primeng/dialog';
import {MegaMenuModule} from 'primeng/megamenu';
import {ProductViewModalComponent} from '../components/product-view-modal/product-view-modal.component';
import {NgSelectModule} from '@ng-select/ng-select';

import {MatIconModule} from "@angular/material/icon";
import {MessageModalComponent} from "../components/message-modal/message-modal.component";

import {AddressModalComponent} from '../components/address-modal/address-modal.component';
import {MobileModalComponent} from '../components/mobile-modal/mobile-modal.component';
import {PaymentFailedModalComponent} from '../components/payment-failed-modal/payment-failed-modal.component';
import {DeleteCartModalComponent} from '../components/delete-cart-modal/delete-cart-modal.component';
import {SizeGuideModalComponent} from '../components/size-guide-modal/size-guide-modal.component';
import {NgxIntlTelInputModule} from "ngx-intl-tel-input-gg";
import {GoogleMapsModule} from "@angular/google-maps";
import {
  SuccessConfirmationModalComponent
} from "../components/modals/confirmation-modal/success-confirmation-modal.component";
import {SuccessModalComponent} from "../components/modals/success-modal/success-modal.component";

@NgModule({
  declarations: [
    ProductCardComponent,
    ProductSliderComponent,
    CategoryCardComponent,
    SectionComponent,
    MessageModalComponent,
    ProductViewModalComponent,
    AddressModalComponent,
    MobileModalComponent,
    PaymentFailedModalComponent,
    DeleteCartModalComponent,
    SizeGuideModalComponent,
    SuccessConfirmationModalComponent,
    SuccessModalComponent,

  ],
  imports: [
    CommonModule,
    TranslateModule,
    CarouselModule,
    BadgeModule,
    SidebarModule,
    ButtonModule,
    InputTextModule,
    DividerModule,
    InputSwitchModule,
    RatingModule,
    ProgressBarModule,
    ProgressSpinnerModule,
    OverlayPanelModule,
    ToastModule,
    FormsModule,
    RouterModule,
    PaginatorModule,
    BreadcrumbModule,

    ModalModule.forRoot(),
    MatMenuModule,
    TieredMenuModule, MegaMenuModule
    , ReactiveFormsModule,
    MatIconModule,
    DialogModule,
    NgSelectModule,
    NgxIntlTelInputModule,
    GoogleMapsModule,


  ],
  exports: [
    CommonModule,
    TranslateModule,
    CarouselModule,
    BadgeModule,
    SidebarModule,
    ButtonModule,
    InputTextModule,
    DividerModule,
    ToastModule,
    InputSwitchModule,
    RatingModule,
    ProgressBarModule,
    ProgressSpinnerModule,
    OverlayPanelModule,
    FormsModule,
    ProductCardComponent,
    ProductSliderComponent,
    SectionComponent,
    CategoryCardComponent,
    AddressModalComponent,
    PaymentFailedModalComponent,
    MobileModalComponent,
    DeleteCartModalComponent,
    SizeGuideModalComponent,
    ProductViewModalComponent,
    RouterModule,
    PaginatorModule,
    BreadcrumbModule,

    MatMenuModule,
    TieredMenuModule,
    MegaMenuModule,
    ModalModule,
    ReactiveFormsModule,
    MatIconModule,
    DialogModule,
    MessageModalComponent,
    NgSelectModule,
    NgxIntlTelInputModule,
    SuccessConfirmationModalComponent,
    SuccessModalComponent
  ]
})
export class SharedModule {
}
